import * as THREE from 'three';
import { Moji } from './Moji';
import gsap from "gsap";
import { Outline } from './Outline';
import { DataManager } from '../data/DataManager';
import { LogoType } from './LogoType';
import { ConnectingDotsRender } from './ConnectingDotsRender';
import { Params } from '../data/Params';
import { ConnectiongDotsCalc } from './ConnectingDotsCalc';
import { MojiDot } from './MojiDot';

//文字の１行分です
export class MojisLine extends THREE.Object3D{

    mojis:Moji[];

    //container:THREE.Object3D;
    counter:number=1;
    counterB:number=1;
    outline:Outline;
    bgLogo:LogoType;
    index:number=0;
    connectedLineRender :ConnectingDotsRender;
    connectedLineCal    :ConnectiongDotsCalc;

    init(oy:number=0,index:number=0,numRatio:number=10){

        this.index=index;

        let q = new Moji(Params.MOJI_Q,-4.011,-0.08, index, numRatio);
        let u = new Moji(Params.MOJI_U,-3.066,0, index, numRatio);
        let a = new Moji(Params.MOJI_A,-2.208,0, index, numRatio);
        let a2 = new Moji(Params.MOJI_A2,-2.208,0, index, numRatio);
        
        let n1 = new Moji(Params.MOJI_N,-1.234,0, index, numRatio);
        let t = new Moji(Params.MOJI_T, -0.3,0, index, numRatio);
        let i = new Moji(Params.MOJI_I, 0.357,0, index, numRatio);
        let n2 = new Moji(Params.MOJI_N,1.087,0, index, numRatio);
        let u1 = new Moji(Params.MOJI_U,2.043,0, index, numRatio);
        let u2 = new Moji(Params.MOJI_U,2.958,0, index, numRatio);
        let m = new Moji(Params.MOJI_M, 4.001+0.01,0, index, numRatio);

        this.mojis=[
            q,u,a,a2,n1,t,i,n2,u1,u2,m
        ];

        this.connectedLineRender = ConnectingDotsRender.getInstance();
        this.connectedLineCal = new ConnectiongDotsCalc();
        this.connectedLineCal.Init(this.mojis);

        for(let i=0;i<this.mojis.length;i++){
            this.add(this.mojis[i]);
        }
        
        this.position.x = Params.LINE_OFFSET_X;
        this.position.y = 200*oy+600;

        //bg
        this.initBg();

    }

    initBg(){

        this.bgLogo = new LogoType( DataManager.getInstance().logo );
        this.bgLogo.position.y = -8;
        this.bgLogo.position.z = Params.Z_LOGO_TYPE;//-400;
        this.bgLogo.scale.set(200,200,200);
        this.add( this.bgLogo );

        this.outline = new Outline();
        this.outline.init(this);
        this.outline.position.z = -300;

    }

    boost(){
        for(let i=0;i<this.mojis.length;i++){
            this.mojis[i].addVelocity();
        }
    }

    setDotsNum(wari:number){
        for(let i=0;i<this.mojis.length;i++){
            //this.mojis[i].addVelocity();
            this.mojis[i].setNum(wari);
        }
        //this.update();
    }

    
    showBgLogo(brightness:number){
        if(this.index==0) this.bgLogo?.showLogo(brightness);
    }

    hideBgLogo(){
        if(this.index==0) this.bgLogo?.hideLogo();
    }

    blink(){
        if(this.index==0){
            this.outline.blink();
            //this.logo.blink();
        }
    }

    blinkBg(ratio:number){
        if(this.index==0){
            this.bgLogo?.blink(ratio);
        }
    }

    tween(){
        for(let i=0;i<this.mojis.length;i++){
            gsap.to(this.position,{
                y:0,
                duration:3,
                ease:"linear"
            });
        }
    }

    update(){
        
        
        for(let i=0;i<this.mojis.length;i++){
            this.mojis[i].update();
        }
        this.connectDots();

    }

    connectDots(){

        if(Params.line_mode==Params.LINE_MODE_NONE){
            //なにもしない
            this.connectedLineRender.hide();
        }else if(Params.line_mode==Params.LINE_MODE_SINGLE){
            this.connectedLineRender.show();
            this.connectedLineCal.Connect();
        }else{
            this.connectedLineRender.show();
            this.connectedLineCal.ConnectHorizonal();
        }
        
    }

    setAllEnabled(b:boolean){
        for(let i=0;i<this.mojis.length;i++){
            this.mojis[i].SetAllEnabled(b);
        }
    }

    getAllDots():MojiDot[]{

        let list:MojiDot[] = [];
        for(let i=0;i<this.mojis.length;i++){
            list = list.concat( this.mojis[i].dots );
        }
        return list;

    }

    getEnabledDots():MojiDot[]{
        
        let list:MojiDot[] = [];
        for(let i=0;i<this.mojis.length;i++){
            list=list.concat(
                this.mojis[i].enabledDots
            );
        }

        return list;
    }

    resize(){

    }

}